import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DocumentGroupService } from 'src/app/Service/DocumentGroup/DocumentGroup.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DocumentGroupAdd',
  templateUrl: './DocumentGroupAdd.component.html',
  styleUrls: ['./DocumentGroupAdd.component.scss']
})
export class DocumentGroupAddComponent implements OnInit {

  Token:String=""

  constructor(
    private DocumentGroup_Service:DocumentGroupService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewDocumentGroup=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,28).subscribe(
      data=>{
        
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewDocumentGroup:FormGroup;

  get_Form_Title(){
    return this.AddNewDocumentGroup.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewDocumentGroup(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    this.InProccessing=true
    this.DocumentGroup_Service.AddDocumentGroup(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list")
        }
        else{
          this.AddNewDocumentGroup.reset()
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
        }
      },error=>{
        localStorage.clear()
        location.reload();
        
      }
    )
  }



}

